import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Q88Component } from './q88.component';

const routes: Routes = [
  {
    path: '',
    component: Q88Component,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Q88RoutingModule {}
